import { render } from "./add-to-compare.vue?vue&type=template&id=3d202a32&ts=true"
import script from "./add-to-compare.vue?vue&type=script&lang=ts"
export * from "./add-to-compare.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__